"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lane = void 0;
const index_1 = require("../Base/index");
/**
 * Describes a BPMN Lane.
 * Note that the lane itself contains only the references to its FlowNodes.
 * The FlowNodes themselves are stored directly in the ProcessModel.
 * This reflects the original XML structure as defined by the BPMN specs.
 */
class Lane extends index_1.BaseElement {
    constructor() {
        super(...arguments);
        this.flowNodeReferences = [];
    }
}
exports.Lane = Lane;
//# sourceMappingURL=Lane.js.map